import React from "react";
import { Section } from "@sainsburys-tech/luna-section";
import { Card } from "@sainsburys-tech/luna-card";
import MultiMissionLogo from "components/MultiMissionLogo";
import missionContent from "missionContent";

const ResetPasswordNotificationMessage = () => {
  return (
    <>
      <Section>
        <Card className="ln-u-text-align-left" style={{ borderRadius: "1em" }}>
          <div
            className="ln-u-margin-bottom"
            style={{
              display: "flex",
              justifyContent: "left",
              flexDirection: "row",
              maxHeight: "40px",
            }}
          >
            <MultiMissionLogo />
          </div>
          <div
            className="ln-u-margin-bottom*1"
            data-testid="reset-password-notification-message"
          >
            {missionContent.resetPasswordNotification}
          </div>
        </Card>
      </Section>
    </>
  );
};

export default ResetPasswordNotificationMessage;
